import { Container } from '@mantine/core';
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SharedMasterPlanDetailModule from 'modules/pages/dacum/sharedMasterPlan/SharedMasterPlanDetail';

const SharedMasterPlanDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();

  const jobFamily = searchParams.get('jobfamily');
  const year = searchParams.get('year');

  return (
    <Container size='xl' py='xl'>
      <SharedMasterPlanDetailModule
        programId={id}
        jobFamily={jobFamily || undefined}
        year={year || undefined}
      />
    </Container>
  );
};

export default SharedMasterPlanDetailPage;
